<!-- 体验版-侧边导航栏 -->
<template>
  <div class="NavBar clearfix">
    <el-menu class="el-menu-vertical-demo navBarBox" background-color="#121920" text-color="#909399"
      active-text-color="#ffffff" :default-active="defaultActive" unique-opened>
      <div v-for="(navItem, navIndex) in navList" :key="navIndex">
        <el-menu-item class="first" :index="navItem.function_tab" @click="getNavBarActive(navIndex)"
          v-if="navItem.children.length == 0">
          <i :class="navItem.icon"></i>
          <span slot="title">{{navItem.function_name}}</span>
        </el-menu-item>
        <!--有2级菜单-->
        <el-submenu :index="navItem.function_tab" v-else>
          <template slot="title">
            <i :class="navItem.icon"></i>
            <span slot="title">{{navItem.function_name}}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item :key="subNavIndex" v-for="(subNavItem, subNavIndex) in navItem.children"
              :index="subNavItem.function_tab" @click="getNavBarActive(navIndex, subNavIndex)">
              {{subNavItem.function_name}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </div>
    </el-menu>
    <!-- <a href="ww"></a> -->
  </div>
</template>

<script>
import {
  localUserInfo,
  updataBreadCrumb,
  getBreadCrumb,
  showToast
} from "../../../../static/js/utility/utility.js"
import { navApi } from "../../../../static/js/api.js"

export default {
  name: 'ExpCNavBar',
  data () {
    return {
      // 导航列表
      navList: [
        {
          function_apply: "C",
          function_id: "1019",
          function_img: "",
          function_name: "用户中心",
          function_order: "2",
          function_show: "true",
          function_soft: "",
          function_tab: "CUserManege",
          function_type: "B",
          parent_function_id: "",
          children: [
            {
              function_apply: "C",
              function_id: "1020",
              function_img: "",
              function_name: "组织管理",
              function_order: "1",
              function_show: "true",
              function_soft: "v4/client/user",
              function_tab: "COrganizeManage",
              function_type: "B",
              parent_function_id: "1019"
            }
          ]
        },
        {
          function_apply: "C",
          function_id: "1023",
          function_img: "",
          function_name: "控制中心",
          function_order: "2",
          function_show: "true",
          function_soft: "",
          function_tab: "CSceneManage",
          function_type: "B",
          parent_function_id: "",
          children: [
            {
              function_apply: "C",
              function_id: "1024",
              function_img: "",
              function_name: "空间管理",
              function_order: "1",
              function_show: "true",
              function_soft: "V4/Client/space",
              function_tab: "CSceneList",
              function_type: "B",
              parent_function_id: "1023"
            },
            {
              function_apply: "C",
              function_id: "1029",
              function_img: "",
              function_name: "授权管理",
              function_order: "2",
              function_show: "true",
              function_soft: "V4/Client/authorized",
              function_tab: "CAuthorizationCenter",
              function_type: "B",
              parent_function_id: "1023"
            },
            {
              function_apply: "C",
              function_id: "1045",
              function_img: "",
              function_name: "设备中心",
              function_order: "3",
              function_show: "true",
              function_soft: "v4/client/equipment",
              function_tab: "CDeviceCenter",
              function_type: "B",
              parent_function_id: "1023"
            }
          ]
        }

      ],
      // 当前显示
      defaultActive: ''
    }
  },
  created () {
  },
  mounted () {
    // console.log('path', this.$route.path)
    // 获取上次选中二级菜单type，刷新页面默认active
    if (getBreadCrumb() && getBreadCrumb().length > 1) {
      this.defaultActive = getBreadCrumb()[1].function_tab
    }
  },
  methods: {
    handleOpen (key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath);
    },
    // 获取导航菜单列表
    getUserAuthList: async function (path) {
      let vm = this
      // 当是登录页和仪表盘页，不能获取菜单列表
      if (path === '/' || path === '/CMap' || path.indexOf('/courier') != '-1') {
        // console.log('123', '')
        // alert('path:'+path)
        return
      } else {
        let res = await navApi.getUserAuthList()
        if (res.meta.code === 200) {
          for (let i in res.data) {
            if (res.data[i].function_tab == 'CMap') {
              // res.data.splice(i,1)
              vm.$store.state.isfunMap = true
            }
          }
          vm.addIcon(res.data)
          // console.log('菜单列表', res.data)
        } else {
          showToast(res.meta.message)
        }
      }
    },
    // 一级菜单添加icon
    addIcon: function (data) {
      let navList = data
      for (let i in navList) {
        switch (navList[i].function_tab) {
          // 仪表盘
          case 'CMap':
            navList[i].icon = 'el-icon-location-outline'
            break;
          // 用户管理
          case 'CUserManege':
            navList[i].icon = 'el-icon-my ico ico-my'
            break;
          // 场景管理
          case 'CSceneManage':
            navList[i].icon = 'el-icon-menu'
            break;
          // 平台运营
          case 'CPlatformOperate':
            navList[i].icon = 'el-icon-printer'
            break;
          // 企业缴费情况
          case 'CEnterprisePayment':
            navList[i].icon = 'el-icon-printer'
            break;
          // 授权管理
          case 'CAuthorizationManage':
            navList[i].icon = 'el-icon-view'
            break;
          // 业务领域
          case 'CBusiness':
            navList[i].icon = 'el-icon-view'
            break;
          // 能耗管理
          case 'CEnergyManage':
            navList[i].icon = 'el-icon-loading'
            break;
          // 碧水湾
          case 'CBsw':
            navList[i].icon = 'ico ico-shop'
            break;
          // 第三方应用
          case 'CThirdApplication':
            navList[i].icon = 'ico ico-link'
            break;
          // 无人仓业务
          case 'CUnmanWarehouse':
            navList[i].icon = 'ico ico-warehouse'
            break;
          //e站
          case 'CESite':
            navList[i].icon = 'ico ico-esite'
            break;
          // 客户管理
          case 'CCustomer':
            navList[i].icon = 'el-icon-my ico ico-my'
            break;
          default:
            break;
        }
      }
      this.navList = [...navList]
    },
    // 获取侧边导航栏选中内容,并显示对应内容
    getNavBarActive: function (navIndex, subNavIndex) {

      console.log('subNavIndex', subNavIndex)
      let hasSub = typeof (subNavIndex) == 'number'
      let navBarActive =
        [
          {
            function_tab: this.navList[navIndex].function_tab,
            function_name: this.navList[navIndex].function_name
          },
        ]
      if (hasSub) {
        navBarActive.push({
          function_tab: this.navList[navIndex].children[subNavIndex].function_tab,
          function_name: this.navList[navIndex].children[subNavIndex].function_name
        })
      }
      // console.log('navBarActive', navBarActive)

      // 更新面包屑内容
      updataBreadCrumb(2, navBarActive)


      // 当跳转第三方网页时
      if (hasSub && this.navList[navIndex].children[subNavIndex].web_tab) {
        let web_tab = this.navList[navIndex].children[subNavIndex].web_tab
        if (web_tab.indexOf('http') !== -1) {
          window.open(web_tab)
        }
      }

      // 默认页面跳转
      this.$router.push(navBarActive[hasSub ? 1 : 0].function_tab)
      // console.log(JSON.parse(sessionStorage.getItem('navBarActive')))
    }
  },
  watch: {
    // 监听没有二级菜单，默认为空
    '$store.state.defaultActive': function (newVal) {
      console.log('newVal', newVal)
      this.defaultActive = newVal
    }
  }
}
</script>

<style lang="scss">
$head-bg-color: rgba(106, 125, 143, 1);

.NavBar {
  flex-shrink: 0;
  width: 236px;
  height: 100%;
  overflow: hidden;
  color: #ffffff;
  background-color: #121920;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  .navBarBox {
    width: 256px !important;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
  }
}

// 侧边导航栏
.el-menu {
  width: 100%;
  border-right: none;
  .el-submenu__title,
  .el-menu-item.first {
    color: #ffffff;
    a {
      color: #ffffff;
    }
  }
  .el-menu-item.is-active {
    color: #ffffff;
    background-color: #0081eb !important;
    margin: 0 !important;
  }
  .el-submenu.is-active {
    i,
    span {
      color: #fff;
    }
  }
  .el-submenu [class^="el-icon-"],
  .el-submenu .ico {
    font-size: 20px;
  }
  .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    // display: none;
  }
  .el-submenu__title,
  .first {
    font-size: 18px;
    height: 58px;
    line-height: 58px;
    color: rgb(255, 255, 255) !important;
    background: #00111f !important;
    margin: 0;
    // .el-submenu__icon-arrow{ display: none;}
  }
  // 二级菜单
  .el-menu-item-group {
    .el-menu-item-group__title {
      padding: 0;
    }
    .el-menu-item {
      font-size: 16px;
      padding-left: 62px !important;
      height: 54px;
      line-height: 54px;
      margin: 0 32px 0 0;
      border-bottom: 1px solid #535353;
      &:hover {
        margin: 0;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
// 导航栏折叠
.el-menu.el-menu--collapse {
  .el-submenu__title span {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
  }
  .el-submenu__icon-arrow {
    // display: none;
  }
  .el-submenu-is-opened .el-submenu__title {
    margin-left: 5px;
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
}

// 悬浮侧边栏
.el-menu--vertical {
  left: 80px !important;
  .el-menu--popup {
    border-radius: 3px;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExpPage/Layout/CNavBar.vue